import { createRoot } from "react-dom/client";
import { Component, type ReactNode } from "react";
import { HeroMatrix } from "@/app/components/matrix/HeroMatrix";
import { BlackHoleSection } from "@/app/components/matrix/BlackHoleSection";
import { TimelineSection } from "@/app/components/matrix/TimelineSection";
import { OmniNexusCards } from "@/app/components/matrix/OmniNexusCards";
import { WebhooksSection } from "@/app/components/matrix/WebhooksSection";
import { BotKillerSection } from "@/app/components/matrix/BotKillerSection";
import { Footer } from "@/app/components/Footer";
import "@/styles/index.css";

// ErrorBoundary pega render errors que try/catch do createRoot nao captura.
class DebugBoundary extends Component<{ children: ReactNode }, { err: Error | null }> {
  state: { err: Error | null } = { err: null };
  static getDerivedStateFromError(err: Error) { return { err }; }
  componentDidCatch(err: Error, info: any) {
    console.error("WPTT-DBG boundary catch", err, info);
  }
  render() {
    if (this.state.err) {
      const msg = String(this.state.err.message);
      const stack = String(this.state.err.stack || '');
      const compStack = String((this.props as any)?.info?.componentStack || '');
      return (
        <div style={{ color: "#ff4d00", fontFamily: "monospace", padding: "2rem", whiteSpace: "pre-wrap", fontSize: "13px", background: "#0a0a0a", minHeight: "100vh" }}>
          WPTT-DBG boundary
          {"\n=== MSG ===\n"}{msg}
          {"\n=== STACK ===\n"}{stack.split("\n").slice(0, 10).join("\n")}
          {"\n=== COMPONENT STACK ===\n"}{compStack.split("\n").slice(0, 10).join("\n")}
        </div>
      );
    }
    return this.props.children;
  }
}

function MatrixPage() {
  return (
    <div className="relative bg-[#050508] overflow-x-hidden">
      <HeroMatrix />
      <BlackHoleSection />
      <TimelineSection />
      <OmniNexusCards />
      <WebhooksSection />
      <BotKillerSection />
      <Footer />
    </div>
  );
}

const rootEl = document.getElementById("root");
try {
  if (!rootEl) throw new Error("WPTT-DBG: #root nao encontrado");
  rootEl.classList.remove("wptt-plugin-loading");
  console.log("WPTT-DBG matrix boot start", { createRoot: typeof createRoot, hasRoot: !!rootEl });
  createRoot(rootEl).render(
    <DebugBoundary>
      <MatrixPage />
    </DebugBoundary>
  );
  console.log("WPTT-DBG matrix render dispatched");
} catch (err) {
  const e: any = err;
  console.error("WPTT-DBG matrix sync FAIL", e);
  if (rootEl) {
    rootEl.classList.remove("wptt-plugin-loading");
    const msg = String(e && e.message ? e.message : e);
    const stack = String(e && e.stack ? e.stack : "");
    rootEl.innerHTML =
      '<div style="color:#ff4d00;font-family:monospace;padding:2rem;white-space:pre-wrap;font-size:13px;background:#0a0a0a;min-height:100vh">WPTT-DBG SYNC FAIL\n=== MSG ===\n' + msg + '\n=== STACK ===\n' + stack.split('\n').slice(0, 10).join('\n') + '</div>';
  }
}
